<app-kamona-custom-dialog [dialogType]="alertType" [kamonaDialogType]="'MOBILE_ALERT_VIEW'">
	<div title>{{ (title | translate) || (alertDefaults.title | translate | titlecase)}}</div>
	<div [innerHTML]="message" message></div>
	<div class="mt-5" message2>{{ (message2 | translate) }}</div>
	<div class="mt-5" message3>{{ (message3 | translate) }}</div>
	<div extraMessage>
		<div *ngIf="extraMessage" class="extra-info">
			<div class="extra-message">
				<div class="detail">
					<svg fill="none" height="24" viewBox="0 0 24 24" width="24"
						 xmlns="http://www.w3.org/2000/svg">
						<path
							d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C21.9939 17.5203 17.5203 21.9939 12 22ZM9.99 10.99V13H10.99V17H14.01V15H13L13.01 10.991L9.99 10.99ZM10.99 7V9.019H13.01V7H10.99Z"
							fill="#0361F0"/>
					</svg>
					<p class="text-black">{{extraMessage}}</p>
				</div>
			</div>
		</div>
	</div>
	<div extraContent>
		<div *ngIf="expiryTime">
			<div class="visible-xs">
				<div class="m-t-28">
					<ng-container *ngTemplateOutlet="otpCountdown"></ng-container>
				</div>
			</div>
			<div class="hidden-xs">
				<div class="m-b-16" style="margin-top: -9px">
					<ng-container *ngTemplateOutlet="otpCountdownWeb"></ng-container>
				</div>
			</div>
		</div>
		<div class="sr-only" tabindex="0"></div>
	</div>
	<div [hidden]="alertType === 'processing'" action>
		<div *ngIf="designType === MONIEPOINT_DESIGN_TYPE.MONIEPOINT_V2 else KamonaBtn">
			<app-custom-button (submitForm)="continue()" [isBlock]="true" [state]="alertDefaults.actionClass"
							   [text]="callbackName? (callbackName|translate) : (alertDefaults.callbackName | translate)"
							   [type]="'primary'">
			</app-custom-button>
		</div>
		<ng-template #KamonaBtn>
			<div class="visible-xs">
				<div class="mobile-dialog-button">
					<app-custom-submit-button
						(submitForm)="continue()"
						[block]="true"
						[name]="callbackName? (callbackName|translate) : (alertDefaults.callbackName | translate)"
						[submitting]="loading">
					</app-custom-submit-button>
				</div>
			</div>
			<div class="hidden-xs">
				<div class="m-t-24 p-l-40 p-r-40">
					<div class="kamona-desktop-button-wrapper">
						<app-custom-submit-button
							(submitForm)="continue()"
							[block]="true"
							[name]="callbackName? (callbackName|translate) : (alertDefaults.callbackName | translate)"
							[submitting]="loading">
						</app-custom-submit-button>
					</div>
				</div>
			</div>
		</ng-template>
	</div>
</app-kamona-custom-dialog>
<ng-template #otpCountdownWeb>
	<div *ngIf="countDown else loadingCountDownWeb" class="text-center">
		<div class="flex items-center gap-3 justify-center text-white md:text-primary">
			<svg fill="none" height="14" viewBox="0 0 14 14" width="14" xmlns="http://www.w3.org/2000/svg">
				<path class="fill-white md:fill-primary"
					d="M12.37 3.62069L11.5452 2.79583L10.6883 3.65272C9.8238 2.94529 8.75403 2.47969 7.58267 2.36303V1.16666H8.74933V0H5.24934V1.16666H6.416V2.36303C3.47251 2.65704 1.16602 5.14739 1.16602 8.16668C1.16602 11.3832 3.78281 14 6.99934 14C10.2159 14 12.8327 11.3832 12.8327 8.16668C12.8327 6.76838 12.3368 5.48335 11.5131 4.47769L12.37 3.62069ZM8.16603 8.16668C8.16603 8.81005 7.64273 9.33334 6.99937 9.33334C6.356 9.33334 5.8327 8.81005 5.8327 8.16668C5.8327 7.52332 6.356 7.00002 6.99937 7.00002C7.10315 7.00002 7.20184 7.01812 7.29742 7.04325L9.50354 4.83765L10.3284 5.66252L8.12228 7.86811C8.14793 7.9642 8.16603 8.06291 8.16603 8.16668Z"
					fill="white"/>
			</svg>
			<span>{{expiryTimeText}}</span>
		</div>
		<div class="dialog-otp-container-web">
			<div>
				<div class="title">
					{{getRefinedTime(countDown.hours)}}
				</div>
				<div class="label">
					Hours
				</div>
			</div>
			<div>
				<ng-container *ngTemplateOutlet="timerDotWeb">
				</ng-container>
			</div>
			<div>
				<div class="title">
					{{getRefinedTime(countDown.minutes)}}
				</div>
				<div class="label">
					Minutes
				</div>
			</div>
			<div>
				<ng-container *ngTemplateOutlet="timerDotWeb">
				</ng-container>
			</div>
			<div>
				<div class="title">
					{{getRefinedTime(countDown.seconds)}}
				</div>
				<div class="label">
					Seconds
				</div>
			</div>
		</div>
	</div>
</ng-template>
<ng-template #otpCountdown>
	<div *ngIf="countDown else loadingCountDown" class="text-center">
		<div style="display: flex; align-items: center; gap: 12px; justify-content: center; color: white;">
			<svg fill="none" height="14" viewBox="0 0 14 14" width="14" xmlns="http://www.w3.org/2000/svg">
				<path
					d="M12.37 3.62069L11.5452 2.79583L10.6883 3.65272C9.8238 2.94529 8.75403 2.47969 7.58267 2.36303V1.16666H8.74933V0H5.24934V1.16666H6.416V2.36303C3.47251 2.65704 1.16602 5.14739 1.16602 8.16668C1.16602 11.3832 3.78281 14 6.99934 14C10.2159 14 12.8327 11.3832 12.8327 8.16668C12.8327 6.76838 12.3368 5.48335 11.5131 4.47769L12.37 3.62069ZM8.16603 8.16668C8.16603 8.81005 7.64273 9.33334 6.99937 9.33334C6.356 9.33334 5.8327 8.81005 5.8327 8.16668C5.8327 7.52332 6.356 7.00002 6.99937 7.00002C7.10315 7.00002 7.20184 7.01812 7.29742 7.04325L9.50354 4.83765L10.3284 5.66252L8.12228 7.86811C8.14793 7.9642 8.16603 8.06291 8.16603 8.16668Z"
					fill="white"/>
			</svg>
			<span>{{expiryTimeText}}</span>
		</div>
		<div class="dialog-otp-container">
			<div>
				<div class="title">
					{{getRefinedTime(countDown.hours)}}
				</div>
				<div class="label">
					Hours
				</div>
			</div>
			<div>
				<ng-container *ngTemplateOutlet="timerDot">
				</ng-container>
			</div>
			<div>
				<div class="title">
					{{getRefinedTime(countDown.minutes)}}
				</div>
				<div class="label">
					Minutes
				</div>
			</div>
			<div>
				<ng-container *ngTemplateOutlet="timerDot">
				</ng-container>
			</div>
			<div>
				<div class="title">
					{{getRefinedTime(countDown.seconds)}}
				</div>
				<div class="label">
					Seconds
				</div>
			</div>
		</div>
	</div>
</ng-template>
<ng-template #loadingCountDown>
	<app-loading [loadingType]="'OTP_LOADER'" [parentHeight]="'20'" [size]="30">
	</app-loading>
</ng-template>
<ng-template #loadingCountDownWeb>
	<app-loading [parentHeight]="'20'" [size]="30">
	</app-loading>
</ng-template>
<ng-template #timerDot>
	<svg fill="none" height="56" viewBox="0 0 12 56" width="12" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M3.14697 34.6562C3.14697 33.9271 3.39437 33.3151 3.88916 32.8203C4.38395 32.3125 5.05452 32.0586 5.90088 32.0586C6.76025 32.0586 7.43083 32.3125 7.9126 32.8203C8.40739 33.3151 8.65479 33.9271 8.65479 34.6562C8.65479 35.3854 8.40739 35.9974 7.9126 36.4922C7.43083 36.987 6.76025 37.2344 5.90088 37.2344C5.05452 37.2344 4.38395 36.987 3.88916 36.4922C3.39437 35.9974 3.14697 35.3854 3.14697 34.6562ZM3.1665 18.0156C3.1665 17.2865 3.4139 16.6745 3.90869 16.1797C4.40348 15.6719 5.07406 15.418 5.92041 15.418C6.77979 15.418 7.45036 15.6719 7.93213 16.1797C8.42692 16.6745 8.67432 17.2865 8.67432 18.0156C8.67432 18.7448 8.42692 19.3568 7.93213 19.8516C7.45036 20.3464 6.77979 20.5938 5.92041 20.5938C5.07406 20.5938 4.40348 20.3464 3.90869 19.8516C3.4139 19.3568 3.1665 18.7448 3.1665 18.0156Z"
			fill="white" fill-opacity="0.5"/>
	</svg>
</ng-template>
<ng-template #timerDotWeb>
	<svg fill="none" height="56" viewBox="0 0 12 56" width="12" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M2.64648 34.6562C2.64648 33.9271 2.89388 33.3151 3.38867 32.8203C3.88346 32.3125 4.55404 32.0586 5.40039 32.0586C6.25977 32.0586 6.93034 32.3125 7.41211 32.8203C7.9069 33.3151 8.1543 33.9271 8.1543 34.6562C8.1543 35.3854 7.9069 35.9974 7.41211 36.4922C6.93034 36.987 6.25977 37.2344 5.40039 37.2344C4.55404 37.2344 3.88346 36.987 3.38867 36.4922C2.89388 35.9974 2.64648 35.3854 2.64648 34.6562ZM2.66602 18.0156C2.66602 17.2865 2.91341 16.6745 3.4082 16.1797C3.90299 15.6719 4.57357 15.418 5.41992 15.418C6.2793 15.418 6.94987 15.6719 7.43164 16.1797C7.92643 16.6745 8.17383 17.2865 8.17383 18.0156C8.17383 18.7448 7.92643 19.3568 7.43164 19.8516C6.94987 20.3464 6.2793 20.5938 5.41992 20.5938C4.57357 20.5938 3.90299 20.3464 3.4082 19.8516C2.91341 19.3568 2.66602 18.7448 2.66602 18.0156Z"
			fill="#0B3275" fill-opacity="0.3"/>
	</svg>
</ng-template>
